import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleActivitiesAnalyticalPerTaskUseCaseInterface } from 'domain/usecases';
import { IActivitiesAnalyticalPerTaskFilters } from 'presentation/app/modules/Reports/models/activities-analytical-per-task-filters';

interface IActivitiesAnalyticalPerTask {
  tasksData: HandleActivitiesAnalyticalPerTaskUseCaseInterface.Result;
  filters: IActivitiesAnalyticalPerTaskFilters;
}

interface IPayloadTasksData
  extends PayloadAction<HandleActivitiesAnalyticalPerTaskUseCaseInterface.Result> {}

interface IPayloadFilters
  extends PayloadAction<IActivitiesAnalyticalPerTaskFilters> {}

const initialState: IActivitiesAnalyticalPerTask = {
  tasksData: [],
  filters: null,
};

export const ActivitiesAnalyticalPerTaskSlice = createSlice({
  name: 'activity-report-internship',
  initialState,
  reducers: {
    loadTasksData: (state, action: IPayloadTasksData) => {
      state.tasksData = action.payload;
    },
    clearTasksData: (state) => {
      state.tasksData = [];
    },
    loadFilters: (state, action: IPayloadFilters) => {
      state.filters = action.payload;
    },
    clearFilters: (state) => {
      state.filters = null;
    },
  },
});

export const { loadTasksData, clearTasksData, loadFilters, clearFilters } =
  ActivitiesAnalyticalPerTaskSlice.actions;

export default ActivitiesAnalyticalPerTaskSlice.reducer;
